import { render, staticRenderFns } from "./ParagraphColumnsText.vue?vue&type=template&id=8d5d7c8c&"
import script from "./ParagraphColumnsText.vue?vue&type=script&lang=js&"
export * from "./ParagraphColumnsText.vue?vue&type=script&lang=js&"
import style0 from "./ParagraphColumnsText.vue?vue&type=style&index=0&id=8d5d7c8c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports